import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { AssociatedVendorModalContent } from './content';
import { SimpleModal } from '@livable/saas-react-components';
export const AssociatedVendorModal = observer(_ref => {
  let customTrigger = _ref.customTrigger,
    utilityProviderId = _ref.utilityProviderId,
    forceUpdate = _ref.forceUpdate;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    formKey = _useState4[0],
    setFormKey = _useState4[1];
  const handleOpen = () => {
    setFormKey(k => k + 1);
    setIsOpen(true);
  };
  const handleClose = () => setIsOpen(false);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noMargin: true,
    noPadding: true,
    isOpen: isOpen,
    handleOpen: handleOpen,
    handleClose: handleClose,
    title: t('add_new_property_flow.change_associated_vendor_in_appfolio'),
    trigger: customTrigger ? customTrigger : /*#__PURE__*/React.createElement(Button, {
      variant: "contained"
    }, "Select vendor")
  }, /*#__PURE__*/React.createElement(AssociatedVendorModalContent, {
    key: formKey,
    utilityProviderId: utilityProviderId,
    forceUpdate: forceUpdate,
    handleModalClose: handleClose
  }));
});